<dacks-local-nav>
  <dacks-local-nav-item><a routerLink="/delivery" routerLinkActive="dacks-active">{{ 'updates.title' | translate }}</a></dacks-local-nav-item>
  <dacks-local-nav-item><a routerLink="/product-change" routerLinkActive="dacks-active">{{ 'product-change.title' | translate }}</a></dacks-local-nav-item>
  <dacks-local-nav-item><a routerLink="/download" routerLinkActive="dacks-active">{{ 'download.title' | translate }}</a></dacks-local-nav-item>
</dacks-local-nav>
